import { combineReducers } from 'redux';

import report from './report/reducer';

export default combineReducers({
  report,
});



// WEBPACK FOOTER //
// ./src/pages/receiptsandcollections/state/reducer.js